import React from "react";
import ProgrammeDetail from "../../ProgrammeDetail";

export const programme = {
  id: "industrial-electronics",
  name: "Industrial Electronics",
  short: "Industrial Electronics",
  programmeType: "pg",
  programmeLabel: "Postgraduate Programme",
  hideSharedClubs: true,
  hideFacultySection: true,
  hideAcademicMeta: true,
  duration: "2 Years",
  intake: 12,
  established: 2011,

  description: [
    "AICTE has granted permission to start the M.Tech course in Industrial Electronics under the Department of Electronics and Communication Engineering from the academic year 2011-12 with an intake of 12 students. The course is affiliated to Visvesvaraya Technological University (VTU), Belagavi. Students having a Bachelor's Degree in E&CE, EEE, TCE and IEE can take this course.",
    "M.Tech. Industrial Electronics is a postgraduate Electronics Engineering course. Industrial Electronic Engineering unites the characteristics of two basic areas of knowledge, namely Automation and Industrial Electronics. It is a growing discipline that is increasingly becoming more competitive in the market. It is essentially Electronics Engineering with specialization in control and automation. This course gives importance to industrial applications of electronics and motivates students to explore new horizons. The course mainly deals with areas like Power Electronics, Industrial Electronics, Control Systems, Communication Systems and Industrial Automation. It also includes a detailed study of microprocessors and microcontrollers with their applications.",
  ],

  image:
    "/COE/micro.jpg",

  hodId: null,

  // dashboard: [
  //   ["Faculty Members", ""],
  //   ["Faculty with Ph.D.", ""],
  //   ["Laboratories", ""],
  //   ["Students Enrolled", ""],
  // ],

  academicOverview: [
    {
      title: "Programme Overview",
      text:
        "Industrial Electronics Engineering combines the principles of electronics, automation, control systems and communication systems. The programme focuses on industrial applications of electronics and equips students with knowledge of power electronics, industrial automation, microprocessors, microcontrollers and modern control techniques.",
    },
    {
      title: "Industry Relevance",
      text:
        "The discipline is growing rapidly due to increasing demand for automation and intelligent industrial systems. Students gain expertise in technologies widely used in manufacturing, process industries and modern industrial infrastructure.",
    },
    {
      title: "Practical Learning",
      text:
        "The programme emphasizes application-oriented learning through laboratory work, industrial case studies, project-based learning and advanced electronics system design.",
    },
    {
      title: "How is M.Tech. Industrial Electronics Course Beneficial?",
      text: [
        "The course gives deeper and complete scientific information in the Industrial Electronics area and is strongly linked to industrial sectors through the teaching staff's vast experience in R&D projects with companies, with its corresponding impact on the master classes.",
        "There is ample scope for starting small scale industries as well.",
      ],
    },
    {
      title: "M.Tech. Industrial Electronics Employment Areas",
      text: [
        "Academic Institutions",
        "R&D Departments",
        "Manufacturing Industries",
        "Automobile Companies",
        "Aeronautics",
        "Fabrication & Designing Companies",
      ],
    },
  ],

  curriculumSupport: [
    "Power Electronics",
    "Industrial Automation",
    "Control Systems",
    "Communication Systems",
    "Microprocessors and Microcontrollers",
    "Embedded Systems",
    "Industrial Instrumentation",
    "Advanced Electronics Applications",
  ],

  achievements: [
    "Specialized postgraduate programme in Industrial Electronics.",
    "Strong focus on industrial automation and control systems.",
    "Application-oriented curriculum aligned with industry needs.",
  ],

  programmeOutcomes: [
    "Engineering knowledge: Apply the knowledge of mathematics, science, engineering fundamentals, and an engineering specialization to the solution of complex engineering problems.",
    "Problem analysis: Identify, formulate, review research literature, and analyze complex engineering problems reaching substantiated conclusions using the first principles of mathematics, natural sciences, and engineering sciences.",
    "Design/development of solutions: Design solutions for complex engineering problems and design system components or processes that meet the specified needs with appropriate consideration for public health and safety and cultural, societal, and environmental considerations.",
    "Conduct investigations of complex problems: Use research-based knowledge and research methods including design of experiments, analysis, interpretation of data, and synthesis of the information to provide valid conclusions.",
    "The engineer and society: Apply to reason informed by the contextual knowledge to assess societal, health, safety, legal and cultural issues and the consequent responsibilities relevant to the professional engineering practice.",
    "Environment and sustainability: Understand the impact of professional engineering solutions in societal and environmental contexts and demonstrate the knowledge of and need for sustainable development.",
    "Ethics: Apply ethical principles and commit to professional ethics and responsibilities and norms of the engineering practice.",
    "Individual and team work: Function effectively as an individual and as a member or leader in diverse teams and in multidisciplinary settings.",
    "Communication: Communicate effectively on complex engineering activities with the engineering community and with society at large, such as being able to comprehend and write effective reports and design documentation, make effective presentations and give and receive clear instructions.",
    "Project management and finance: Demonstrate knowledge and understanding of the engineering and management principles and apply these to one’s own work, as a member and leader in a team, to manage projects and in multidisciplinary environments.",
    "Recognize the need for lifelong learning and adapt to technological changes in mechanical engineering and allied fields.",
  ],

  employmentAreas: [
    "Academic Institutions",
    "R&D Departments",
    "Manufacturing Industries",
    "Automobile Companies",
    "Aeronautics",
    "Fabrication and Designing Companies",
  ],

  infrastructure: [
    ["Classrooms", "Smart Classrooms"],
    ["Laboratories", "Industrial Electronics Laboratory"],
    ["Software Tools", "To be updated"],
    ["Research Facilities", "To be updated"],
  ],

  accreditation: [
    "Affiliated to Visvesvaraya Technological University (VTU), Belagavi",
    "Approved by AICTE",
  ],
};

const IndustrialElectronics = () => (
  <ProgrammeDetail programme={programme} />
);

export default IndustrialElectronics;
